import { render, staticRenderFns } from "./phone-input.vue?vue&type=template&id=8fe45e6e"
import script from "./phone-input.vue?vue&type=script&lang=js"
export * from "./phone-input.vue?vue&type=script&lang=js"
import style0 from "./phone-input.vue?vue&type=style&index=0&id=8fe45e6e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports